import { render } from "./SchemaFormPage.vue?vue&type=template&id=148cd9eb&scoped=true"
import script from "./SchemaFormPage.vue?vue&type=script&lang=js"
export * from "./SchemaFormPage.vue?vue&type=script&lang=js"

import "./SchemaFormPage.vue?vue&type=style&index=0&id=148cd9eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148cd9eb"]])

export default __exports__